package com.essntl.uikit.components.svg

import androidx.compose.runtime.*
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.graphics.nativeCanvas
import androidx.compose.ui.graphics.painter.Painter
import com.essntl.core.network.IO
import com.essntl.uikit.components.utils.esSvgPath
import com.essntl.uikit.resources.LocalRes
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import org.jetbrains.skia.Data
import org.jetbrains.skia.Rect
import org.jetbrains.skia.svg.SVGDOM
import org.jetbrains.skia.svg.SVGLength
import org.jetbrains.skia.svg.SVGLengthUnit

@Composable
actual fun loadSvgPainter(icon: String): Painter {
    val res = LocalRes.current

    var painter by remember {
        mutableStateOf<Painter>(EmptyPainter)
    }

    LaunchedEffect(icon) {
        withContext(Dispatchers.IO) {
            try {
                val bytes = res.readBytes(esSvgPath(icon))
                val svg = SVGDOM(Data.makeFromBytes(bytes))
                painter = SvgPainter(svg)
            } catch (e: Exception) {
                e.printStackTrace()
            }
        }
    }

    return painter
}

@Composable
actual fun loadSvgPainterFromBytes(bytes: ByteArray): Painter =
    remember {
        val svg = try {
            SVGDOM(Data.makeFromBytes(bytes))
        } catch (e: Exception) {
            e.printStackTrace()
            null
        }
        SvgPainter(svg)
    }

object EmptyPainter : Painter() {
    override val intrinsicSize: Size =
        Size.Unspecified

    override fun DrawScope.onDraw() {}
}

class SvgPainter(
    private val svg: SVGDOM?,
) : Painter() {
    override var intrinsicSize: Size =
        Size.Unspecified

    override fun DrawScope.onDraw() {
        if (svg == null) return

        val svgWidth: Float
        val svgHeight: Float
        val viewBox: Rect? = svg.root?.viewBox

        if (viewBox != null) {
            svgWidth = viewBox.width
            svgHeight = viewBox.height
        } else {
            svgWidth = svg.root?.width?.value ?: 0f
            svgHeight = svg.root?.height?.value ?: 0f
        }

        // Set the SVG's view box to enable scaling if it is not set.
        if (viewBox == null && svgWidth > 0f && svgHeight > 0f) {
            svg.root?.viewBox = Rect.makeWH(svgWidth, svgHeight)
        }

        svg.root?.width = SVGLength(
            value = 100f,
            unit = SVGLengthUnit.PERCENTAGE,
        )

        svg.root?.height = SVGLength(
            value = 100f,
            unit = SVGLengthUnit.PERCENTAGE,
        )

        svg.setContainerSize(size.width, size.height)

        svg.render(drawContext.canvas.nativeCanvas)
    }
}